import { render } from "./disambiguation.template.html?vue&type=template&id=4eb57b94&scoped=true"
import script from "./Disambiguation.vue?vue&type=script&lang=ts"
export * from "./Disambiguation.vue?vue&type=script&lang=ts"

import "./Disambiguation.vue?vue&type=style&index=0&id=4eb57b94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4eb57b94"

export default script